import { calcAvgMoisture } from '../../../utils/harvestData';

/**
 *
 * @param {Array} seasons
 * @returns {Array}
 */
export function parseHarvestSeasons(seasons) {
  if (!seasons || !seasons.length) {
    return [];
  }

  return seasons.map((season) => ({
    ...season,
    mass: {
      ...season.mass,
      avgMoisture: calcAvgMoisture(season.mass.moisture.q, season.mass.wet.q),
    },
  }));
}
